import {
  MyApprovalRequestType,
  MyApprovalRequestTypes,
  MyApprovalsState,
} from "./data.type";


const initialState: MyApprovalsState = {
  limit: 50,
  lastDays: -1,
  requestor: "",
  context: [2, 43, 44, 45],
  status: ["APPROVED", "CREATED", "SUBMITTED", "REJECTED"],
  search: "",
  hasFilterApplied: false,
  offset:0,
  dataResults: null
};

function reducer(
  state: MyApprovalsState,
  action: MyApprovalRequestType,
): MyApprovalsState {
  switch (action.type) {
    case MyApprovalRequestTypes.SET_LIMIT:
      return {
        ...state,
        limit: action.payload.limit!
      };

    case MyApprovalRequestTypes.SET_LAST_DAYS:
      return {
        ...state,
        lastDays: action.payload.lastDays!
      };

    case MyApprovalRequestTypes.SET_REQUESTOR:
      return {
        ...state,
        requestor: action.payload.requestor!
      };

    case MyApprovalRequestTypes.SET_CONTEXT:
      return {
        ...state,
        context: action.payload.context!
      };

    case MyApprovalRequestTypes.SET_STATUS:
      return {
        ...state,
        status: action.payload.status!
      };

    case MyApprovalRequestTypes.SET_SEARCH:
      return {
        ...state,
        search: action.payload.search!
      };

    case MyApprovalRequestTypes.SET_FILTER_APPLIED:
      return {
        ...state,
        hasFilterApplied: action.payload.hasFilterApplied!
      };

    case MyApprovalRequestTypes.SET_OFFSET:
      return {
        ...state,
        offset: action.payload.offset!
      };

    case MyApprovalRequestTypes.SET_DATA_RESULTS:
      return {
        ...state,
        dataResults: action.payload.dataResults
      };

    default:
      return state;
  }
}

export const isStateEqualToInitialState = (state: MyApprovalsState): boolean => {
  return (
    state.limit === initialState.limit &&
    state.lastDays === initialState.lastDays &&
    state.requestor === initialState.requestor &&
    JSON.stringify(state.context) === JSON.stringify(initialState.context) &&
    JSON.stringify(state.status) === JSON.stringify(initialState.status) &&
    state.search === initialState.search &&
    state.hasFilterApplied === initialState.hasFilterApplied &&
    state.offset === initialState.offset &&
    state.dataResults === initialState.dataResults
  );
};


export const MyApprovalsReducer = { initialState, reducer };
